import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg, fmtDate } from "@/lib/api";
import { LEAD_STAGES } from "@/lib/constants";
import { PageHeader } from "@/components/common";
import { LostReasonDialog } from "@/admin/Dialogs";

export default function Pipeline() {
  const [items, setItems] = useState([]);
  const [lostFor, setLostFor] = useState(null);
  const load = () => api.get("/admin/pipeline").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const move = (id, status, lost_reason = "") => api.post(`/admin/customers/${id}/status`, { status, lost_reason }).then(() => { toast.success("Stage updated"); load(); }).catch((e) => toast.error(errMsg(e)));
  return (
    <div>
      <PageHeader title="Lead Pipeline" subtitle="Move leads between the 12 stages. Status changes are timestamped in each customer's history." />
      <div className="flex gap-4 overflow-x-auto pb-4">
        {LEAD_STAGES.map(([stage, name]) => {
          const col = items.filter((c) => c.lead_status === stage);
          return (
            <div key={stage} className="w-72 shrink-0 rounded-xl bg-slate-100 p-3" data-testid={`pipeline-column-${stage}`}>
              <p className="mb-3 flex items-center justify-between px-1 text-sm font-bold text-slate-800">{name}<span className="rounded-full bg-white px-2 text-xs text-slate-600">{col.length}</span></p>
              <div className="space-y-2">
                {col.map((c) => (
                  <div key={c.id} className="rounded-lg border border-slate-200 bg-white p-3 shadow-sm" data-testid="lead-pipeline-stage-card">
                    <Link to={`/admin/customers/${c.id}`} className="font-semibold text-slate-900 hover:text-emerald-800">{c.first_name} {c.last_name}</Link>
                    <p className="text-xs text-slate-500">{[c.city, c.state].filter(Boolean).join(", ")} · {c.lead_source}</p>
                    {c.next_follow_up && <p className="text-xs text-amber-700">Follow-up {fmtDate(c.next_follow_up)}</p>}
                    <select value={stage} onChange={(e) => (e.target.value === "lost_lead" ? setLostFor(c.id) : move(c.id, e.target.value))} data-testid={`pipeline-move-${c.id}`} className="mt-2 h-8 w-full rounded-md border border-slate-200 px-2 text-xs">
                      {LEAD_STAGES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                    </select>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
      <LostReasonDialog open={!!lostFor} onClose={() => setLostFor(null)} onConfirm={(r) => { move(lostFor, "lost_lead", r); setLostFor(null); }} />
    </div>
  );
}
